import { FC } from "react";

import AccessAlarmRoundedIcon from "@mui/icons-material/AccessAlarmRounded";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import AddAlarmRoundedIcon from "@mui/icons-material/AddAlarmRounded";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import AodRoundedIcon from "@mui/icons-material/AodRounded";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AvTimerRoundedIcon from "@mui/icons-material/AvTimerRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import BlockIcon from "@mui/icons-material/Block";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import BuildIcon from "@mui/icons-material/Build";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import BusinessIcon from "@mui/icons-material/Business";
import CachedIcon from "@mui/icons-material/Cached";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CampaignIcon from "@mui/icons-material/Campaign";
import CancelIcon from "@mui/icons-material/Cancel";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import CategoryIcon from "@mui/icons-material/Category";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DescriptionIcon from "@mui/icons-material/Description";
import DeveloperBoardRoundedIcon from "@mui/icons-material/DeveloperBoardRounded";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import DomainIcon from "@mui/icons-material/Domain";
import DownloadIcon from "@mui/icons-material/Download";
import DvrIcon from "@mui/icons-material/Dvr";
import EventIcon from "@mui/icons-material/Event";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ExtensionIcon from "@mui/icons-material/Extension";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import HistoryIcon from "@mui/icons-material/History";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatLineSpacingIcon from "@mui/icons-material/FormatLineSpacing";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatListNumberedRtlIcon from "@mui/icons-material/FormatListNumberedRtl";
import ForumIcon from "@mui/icons-material/Forum";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import GradingIcon from "@mui/icons-material/Grading";
import GroupIcon from "@mui/icons-material/Group";
import GroupsIcon from "@mui/icons-material/Groups";
import Groups2Icon from "@mui/icons-material/Groups2";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import HomeIcon from "@mui/icons-material/Home";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import HourglassBottomRoundedIcon from "@mui/icons-material/HourglassBottomRounded";
import HourglassEmptyRoundedIcon from "@mui/icons-material/HourglassEmptyRounded";
import HourglassFullRoundedIcon from "@mui/icons-material/HourglassFullRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import {
  default as HowToRegIcon,
  default as PeopleIcon,
} from "@mui/icons-material/HowToReg";
import ImageIcon from "@mui/icons-material/Image";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import KeyIcon from "@mui/icons-material/Key";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import LeakAddIcon from "@mui/icons-material/LeakAdd";
import LensBlurIcon from "@mui/icons-material/LensBlur";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import ListIcon from "@mui/icons-material/List";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import MailRoundedIcon from "@mui/icons-material/MailRounded";
import MessageIcon from "@mui/icons-material/Message";
import MessageRoundedIcon from "@mui/icons-material/MessageRounded";
import MonitorIcon from "@mui/icons-material/Monitor";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import NotesIcon from "@mui/icons-material/Notes";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PaidIcon from "@mui/icons-material/Paid";
import PasswordIcon from "@mui/icons-material/Password";
import PaymentIcon from "@mui/icons-material/Payment";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import PersonIcon from "@mui/icons-material/Person";
import PhoneCallbackRoundedIcon from "@mui/icons-material/PhoneCallbackRounded";
import PhoneInTalkRoundedIcon from "@mui/icons-material/PhoneInTalkRounded";
import PhonelinkIcon from "@mui/icons-material/Phonelink";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import PublicIcon from "@mui/icons-material/Public";
import QuickreplyRoundedIcon from "@mui/icons-material/QuickreplyRounded";
import QuizIcon from "@mui/icons-material/Quiz";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import RuleIcon from "@mui/icons-material/Rule";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ScreenshotRoundedIcon from "@mui/icons-material/ScreenshotRounded";
import SendIcon from "@mui/icons-material/Send";
import SensorsIcon from "@mui/icons-material/Sensors";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";
import SmsIcon from "@mui/icons-material/Sms";
import SnoozeRoundedIcon from "@mui/icons-material/SnoozeRounded";
import SortIcon from "@mui/icons-material/Sort";
import SpaIcon from "@mui/icons-material/Spa";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import SpeakerNotesOffIcon from "@mui/icons-material/SpeakerNotesOff";
import SsidChartIcon from "@mui/icons-material/SsidChart";
import SubtitlesOffIcon from "@mui/icons-material/SubtitlesOff";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import SyncIcon from "@mui/icons-material/Sync";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import TaskIcon from "@mui/icons-material/Task";
import TerminalIcon from "@mui/icons-material/Terminal";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import ThreePRoundedIcon from "@mui/icons-material/ThreePRounded";
import TodayIcon from "@mui/icons-material/Today";
import TryRoundedIcon from "@mui/icons-material/TryRounded";
import TuneIcon from "@mui/icons-material/Tune";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import WebIcon from "@mui/icons-material/Web";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WidgetsRoundedIcon from "@mui/icons-material/WidgetsRounded";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";
import PermContactCalendarRoundedIcon from "@mui/icons-material/PermContactCalendarRounded";
import PauseCircleFilledRoundedIcon from "@mui/icons-material/PauseCircleFilledRounded";
import CardMembershipRoundedIcon from "@mui/icons-material/CardMembershipRounded";
import MiscellaneousServicesRoundedIcon from "@mui/icons-material/MiscellaneousServicesRounded";
import RuleFolderRoundedIcon from "@mui/icons-material/RuleFolderRounded";
import ClearAllRoundedIcon from "@mui/icons-material/ClearAllRounded";
import VaccinesOutlinedIcon from "@mui/icons-material/VaccinesOutlined";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import SafetyDividerRoundedIcon from "@mui/icons-material/SafetyDividerRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import PhoneLockedIcon from "@mui/icons-material/PhoneLocked";
import AccessTime from "@mui/icons-material/AccessTime";
import { SvgIcon, SvgIconProps } from "@mui/material";

import {
  PersonalInjuryIcon,
  PersonCancelIcon,
  PersonCheckIcon,
  PersonManageIcon,
  StethoscopeIcon,
  Sun,
  WeatherNight,
  WeatherSunsetDown,
  WeatherSunsetUp,
} from "./CustomIcons";
interface IDynamicIcon {
  icon?: string | null;
}

const DynamicIcon: FC<SvgIconProps & IDynamicIcon> = ({ icon, ...props }) => {
  switch (icon) {
    case "ListIcon":
      return <ListIcon {...props} />;
    case "ListAltIcon":
      return <ListAltIcon {...props} />;
    case "HomeIcon":
      return <HomeIcon {...props} />;
    case "FormatListNumberedIcon":
      return <FormatListNumberedIcon {...props} />;
    case "DescriptionIcon":
      return <DescriptionIcon {...props} />;
    case "ReceiptLong":
      return <ReceiptLongIcon {...props} />;
    case "PersonIcon":
      return <PersonIcon {...props} />;
    case "BusinessIcon":
      return <BusinessIcon {...props} />;
    case "HistoryEduIcon":
      return <HistoryEduIcon {...props} />;
    case "HistoryIcon":
      return <HistoryIcon {...props} />;
    case "ContactPageIcon":
      return <ContactPageIcon {...props} />;
    case "AccountBoxIcon":
      return <AccountBoxIcon {...props} />;
    case "ApartmentIcon":
      return <ApartmentIcon {...props} />;
    case "TuneIcon":
      return <TuneIcon {...props} />;
    case "LanguageIcon":
      return <LanguageIcon {...props} />;
    case "DataObjectIcon":
      return <DataObjectIcon {...props} />;
    case "PublicIcon":
      return <PublicIcon {...props} />;
    case "WebIcon":
      return <WebIcon {...props} />;
    case "SsidChartIcon":
      return <SsidChartIcon {...props} />;
    case "AccountBalanceIcon":
      return <AccountBalanceIcon {...props} />;
    case "ExtensionIcon":
      return <ExtensionIcon {...props} />;
    case "SettingsSuggestIcon":
      return <SettingsSuggestIcon {...props} />;
    case "LocationCityIcon":
      return <LocationCityIcon {...props} />;
    case "CorporateFareIcon":
      return <CorporateFareIcon {...props} />;
    case "FlagCircleIcon":
      return <FlagCircleIcon {...props} />;
    case "MapsHomeWorkIcon":
      return <MapsHomeWorkIcon {...props} />;
    case "HolidayVillageIcon":
      return <HolidayVillageIcon {...props} />;
    case "PhonelinkIcon":
      return <PhonelinkIcon {...props} />;
    case "DisplaySettingsIcon":
      return <DisplaySettingsIcon {...props} />;
    case "DomainIcon":
      return <DomainIcon {...props} />;
    case "EventIcon":
      return <EventIcon {...props} />;
    case "SupportAgentIcon":
      return <SupportAgentIcon {...props} />;
    case "RuleIcon":
      return <RuleIcon {...props} />;
    case "HelpOutlineIcon":
      return <HelpOutlineIcon {...props} />;
    case "ConfirmationNumberIcon":
      return <ConfirmationNumberIcon {...props} />;
    case "ForumIcon":
      return <ForumIcon {...props} />;
    case "PermPhoneMsgIcon":
      return <PermPhoneMsgIcon {...props} />;
    case "PendingActionsIcon":
      return <PendingActionsIcon {...props} />;
    case "PlaylistRemoveIcon":
      return <PlaylistRemoveIcon {...props} />;
    case "NewspaperIcon":
      return <NewspaperIcon {...props} />;
    case "NotificationsIcon":
      return <NotificationsIcon {...props} />;
    case "ImageIcon":
      return <ImageIcon {...props} />;
    case "PaymentIcon":
      return <PaymentIcon {...props} />;
    case "SmartToyIcon":
      return <SmartToyIcon {...props} />;
    case "MarkAsUnreadIcon":
      return <MarkAsUnreadIcon {...props} />;
    case "ManageSearchIcon":
      return <ManageSearchIcon {...props} />;
    case "MailRoundedIcon":
      return <MailRoundedIcon {...props} />;
    case "CachedIcon":
      return <CachedIcon {...props} />;
    case "LocalShippingIcon":
      return <LocalShippingIcon {...props} />;
    case "PaidIcon":
      return <PaidIcon {...props} />;
    case "ShareLocationIcon":
      return <ShareLocationIcon {...props} />;
    case "ImportantDevicesIcon":
      return <ImportantDevicesIcon {...props} />;
    case "VolunteerActivismIcon":
      return <VolunteerActivismIcon {...props} />;
    case "TextSnippetIcon":
      return <TextSnippetIcon {...props} />;
    case "Diversity3Icon":
      return <Diversity3Icon {...props} />;
    case "GroupsIcon":
      return <GroupsIcon {...props} />;
    case "BuildCircleIcon":
      return <BuildCircleIcon {...props} />;
    case "DvrIcon":
      return <DvrIcon {...props} />;
    case "BuildIcon":
      return <BuildIcon {...props} />;
    case "KeyIcon":
      return <KeyIcon {...props} />;
    case "SyncIcon":
      return <SyncIcon {...props} />;
    case "SyncAltIcon":
      return <SyncAltIcon {...props} />;
    case "HomeWorkIcon":
      return <HomeWorkIcon {...props} />;
    case "PersonalInjury":
      return <PersonalInjuryIcon />;
    case "Stethoscope":
      return <StethoscopeIcon />;
    case "PersonManage":
      return <PersonManageIcon />;
    case "PersonCheck":
      return <PersonCheckIcon />;
    case "PersonCancel":
      return <PersonCancelIcon />;
    case "LeakAddIcon":
      return <LeakAddIcon {...props} />;
    case "FavoriteIcon":
      return <FavoriteIcon {...props} />;
    case "SpaIcon":
      return <SpaIcon {...props} />;
    case "Groups2Icon":
      return <Groups2Icon {...props} />;
    case "Diversity2Icon":
      return <Diversity2Icon {...props} />;
    case "ContentPasteIcon":
      return <ContentPasteIcon {...props} />;
    case "BlockIcon":
      return <BlockIcon {...props} />;
    case "NotesIcon":
      return <NotesIcon {...props} />;
    case "FormatAlignLeftIcon":
      return <FormatAlignLeftIcon {...props} />;
    case "FactCheckIcon":
      return <FactCheckIcon {...props} />;
    case "ChecklistIcon":
      return <ChecklistIcon {...props} />;
    case "MonitorHeartIcon":
      return <MonitorHeartIcon {...props} />;
    case "GradingIcon":
      return <GradingIcon {...props} />;
    case "CalendarMonthIcon":
      return <CalendarMonthIcon {...props} />;
    case "DateRangeIcon":
      return <DateRangeIcon {...props} />;
    case "EventAvailableIcon":
      return <EventAvailableIcon {...props} />;
    case "AssignmentTurnedInIcon":
      return <AssignmentTurnedInIcon {...props} />;
    case "QuizIcon":
      return <QuizIcon {...props} />;
    case "ArticleIcon":
      return <ArticleIcon {...props} />;
    case "RecentActorsIcon":
      return <RecentActorsIcon {...props} />;
    case "TodayIcon":
      return <TodayIcon {...props} />;
    case "EventNoteIcon":
      return <EventNoteIcon {...props} />;
    case "ViewHeadlineIcon":
      return <ViewHeadlineIcon {...props} />;
    case "PrecisionManufacturingIcon":
      return <PrecisionManufacturingIcon {...props} />;
    case "SensorsIcon":
      return <SensorsIcon {...props} />;
    case "WhatsAppIcon":
      return <WhatsAppIcon {...props} />;
    case "CalendarTodayIcon":
      return <CalendarTodayIcon {...props} />;
    case "WeatherSunsetDown":
      return (
        <SvgIcon component={WeatherSunsetDown} inheritViewBox {...props} />
      );
    case "WeatherSunsetUp":
      return <SvgIcon component={WeatherSunsetUp} inheritViewBox {...props} />;
    case "WeatherNight":
      return <SvgIcon component={WeatherNight} inheritViewBox {...props} />;
    case "Sun":
      return <SvgIcon component={Sun} inheritViewBox {...props} />;
    case "DownloadIcon":
      return <DownloadIcon {...props} />;
    case "TerminalIcon":
      return <TerminalIcon {...props} />;
    case "RssFeedIcon":
      return <RssFeedIcon {...props} />;
    case "LensBlurIcon":
      return <LensBlurIcon {...props} />;
    case "RuleFolderIcon":
      return <RuleFolderIcon {...props} />;
    case "RoomPreferencesIcon":
      return <RoomPreferencesIcon {...props} />;
    case "ReceiptLongIcon":
      return <ReceiptLongIcon {...props} />;
    case "ChecklistRtlIcon":
      return <ChecklistRtlIcon {...props} />;
    case "SwitchAccountIcon":
      return <SwitchAccountIcon {...props} />;
    case "CancelPresentationIcon":
      return <CancelPresentationIcon {...props} />;
    case "FilePresentIcon":
      return <FilePresentIcon {...props} />;
    case "FormatListNumberedRtlIcon":
      return <FormatListNumberedRtlIcon {...props} />;
    case "CardGiftcardIcon":
      return <CardGiftcardIcon {...props} />;
    case "AssignmentIndIcon":
      return <AssignmentTurnedInIcon {...props} />;
    case "AllInboxIcon":
      return <AllInboxIcon {...props} />;
    case "CampaignIcon":
      return <CampaignIcon {...props} />;
    case "CompareArrows":
      return <CompareArrowsIcon {...props} />;
    case "CompareArrowsIcon":
      return <CompareArrowsIcon {...props} />;
    case "SupervisedUserCircleIcon":
      return <SupervisedUserCircleIcon {...props} />;
    case "RequestQuoteIcon":
      return <RequestQuoteIcon {...props} />;
    case "CheckCircleIcon":
      return <CheckCircleIcon {...props} />;
    case "CancelIcon":
      return <CancelIcon {...props} />;
    case "DisabledByDefaultIcon":
      return <DisabledByDefaultIcon {...props} />;
    case "MessageIcon":
      return <MessageIcon {...props} />;
    case "DocumentScannerIcon":
      return <DocumentScannerIcon {...props} />;
    case "HowToRegIcon":
      return <HowToRegIcon {...props} />;
    case "BorderColorIcon":
      return <BorderColorIcon {...props} />;
    case "PeopleIcon":
      return <PeopleIcon {...props} />;
    case "TaskIcon":
      return <TaskIcon {...props} />;
    case "FormatListBulletedIcon":
      return <FormatListBulletedIcon {...props} />;
    case "MonitorIcon":
      return <MonitorIcon {...props} />;
    case "InsertDriveFileIcon":
      return <InsertDriveFileIcon {...props} />;
    case "AccountBoxRounded":
      return <AccountBoxRoundedIcon {...props} />;
    case "DashboardRounded":
      return <DashboardRoundedIcon {...props} />;
    case "WorkspacesRounded":
      return <WorkspacesRoundedIcon {...props} />;
    case "PeopleAltRounded":
      return <PeopleAltRoundedIcon {...props} />;
    case "ScreenshotIcon":
      return <ScreenshotRoundedIcon {...props} />;
    case "AodIcon":
      return <AodRoundedIcon {...props} />;
    case "SortIcon":
      return <SortIcon {...props} />;
    case "DashboardCustomize":
      return <DashboardCustomizeIcon {...props} />;
    case "SpaceDashboard":
      return <SpaceDashboardIcon {...props} />;
    case "QuickreplyIcon":
      return <QuickreplyRoundedIcon {...props} />;
    case "DeveloperBoard":
      return <DeveloperBoardRoundedIcon {...props} />;
    case "Message":
      return <MessageRoundedIcon {...props} />;
    case "Forum":
      return <ForumRoundedIcon {...props} />;
    case "Try":
      return <TryRoundedIcon {...props} />;
    case "ThreeP":
      return <ThreePRoundedIcon {...props} />;
    case "HourglassBottom":
      return <HourglassBottomRoundedIcon {...props} />;
    case "HourglassFull":
      return <HourglassFullRoundedIcon {...props} />;
    case "HourglassTop":
      return <HourglassTopRoundedIcon {...props} />;
    case "HourglassEmpty":
      return <HourglassEmptyRoundedIcon {...props} />;
    case "PhoneCallback":
      return <PhoneCallbackRoundedIcon {...props} />;
    case "SupportAgent":
      return <SupportAgentRoundedIcon {...props} />;
    case "PhoneInTalk":
      return <PhoneInTalkRoundedIcon {...props} />;
    case "SmartToy":
      return <SmartToyRoundedIcon {...props} />;
    case "Badge":
      return <BadgeRoundedIcon {...props} />;
    case "AccessAlarm":
      return <AccessAlarmRoundedIcon {...props} />;
    case "AvTimer":
      return <AvTimerRoundedIcon {...props} />;
    case "AddAlarm":
      return <AddAlarmRoundedIcon {...props} />;
    case "Snooze":
      return <SnoozeRoundedIcon {...props} />;
    case "PasswordIcon":
      return <PasswordIcon {...props} />;
    case "RemoveCircleIcon":
      return <RemoveCircleIcon {...props} />;
    case "SmsIcon":
      return <SmsIcon {...props} />;
    case "LowPriorityIcon":
      return <LowPriorityIcon {...props} />;
    case "LibraryAddCheckIcon":
      return <LibraryAddCheckIcon {...props} />;
    case "SubtitlesOffIcon":
      return <SubtitlesOffIcon {...props} />;
    case "SpeakerNotesOffIcon":
      return <SpeakerNotesOffIcon {...props} />;
    case "FormatLineSpacingIcon":
      return <FormatLineSpacingIcon {...props} />;
    case "GroupIcon":
      return <GroupIcon {...props} />;
    case "LabelOutlinedIcon":
      return <LabelOutlinedIcon {...props} />;
    case "CategoryIcon":
      return <CategoryIcon {...props} />;
    case "ChatBubbleOutlineIcon":
      return <ChatBubbleOutlineIcon {...props} />;
    case "MiscellaneousServicesRoundedIcon":
      return <MiscellaneousServicesRoundedIcon {...props} />;
    case "SendIcon":
      return <SendIcon {...props} />;
    case "ScheduleIcon":
      return <ScheduleIcon {...props} />;
    case "PermContactCalendarRoundedIcon":
      return <PermContactCalendarRoundedIcon {...props} />;
    case "PauseCircleFilledRoundedIcon":
      return <PauseCircleFilledRoundedIcon {...props} />;
    case "CardMembershipRoundedIcon":
      return <CardMembershipRoundedIcon {...props} />;
    case "RuleFolderRoundedIcon":
      return <RuleFolderRoundedIcon {...props} />;
    case "ClearAllRoundedIcon":
      return <ClearAllRoundedIcon {...props} />;
    case "WorkspacesRoundedIcon":
      return <WorkspacesRoundedIcon {...props} />;
    case "WidgetsRoundedIcon":
      return <WidgetsRoundedIcon {...props} />;
    case "VaccinesOutlinedIcon":
      return <VaccinesOutlinedIcon {...props} />;
    case "KeyRoundedIcon":
      return <KeyRoundedIcon {...props} />;
    case "SafetyDividerRoundedIcon":
      return <SafetyDividerRoundedIcon {...props} />;
    case "AssignmentRoundedIcon":
      return <AssignmentRoundedIcon {...props} />;
    case "SwapHorizIcon":
      return <SwapHorizIcon {...props} />;
    case "AirportShuttleIcon":
      return <AirportShuttleIcon {...props} />;
    case "AssignmentReturnIcon":
      return <AssignmentReturnIcon {...props} />;
    case "AssignmentReturnedIcon":
      return <AssignmentReturnedIcon {...props} />;
    case "Analytics":
      return <AnalyticsIcon {...props} />;
    case "PhoneLockedIcon":
      return <PhoneLockedIcon {...props} />;
    case "AccessTime":
      return <AccessTime {...props} />;
    case "Settings":
      return <SettingsIcon {...props} />;
    default:
      return <ErrorOutlineIcon {...props} />;
  }
};

export default DynamicIcon;
